import React, { useState, useMemo, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CircularProgress } from "@mui/material";
import Divider from '@mui/material/Divider';
import AddIcon from "@mui/icons-material/Add";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const checkedIcon = <CheckBoxIcon fontSize="small" />;

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
import Button from '@mui/material/Button';
import { logout } from "actions/auth";
import {
  getCustomers, getProductTypes, updateCustProductTypes, getProbeListByCustomerId,
  getAuthProviders, getAuthProviderByCustomerId, getUserRoles, deleteCustomer, getBilledCustomers, getDemoCustomers,
  activateCustomerAccount, deactivateCustomerAccount, setCustomerAccountTypeToDemo, setCustomerAccountTypeToBilled
} from "apis/CustomersApis";
import { getLicenses, getLicenseHistoryByCustomerId, updateCustomerLicense } from "apis/LicensesApis";
import { useTheme } from '@mui/material/styles';

import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import BilledCustomers from "./BilledCustomers";
import DemoCustomers from "./DemoCustomers";
import AddCustomerDialog from "./AddCustomer";
const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`customer-tabpanel-${index}`}
      aria-labelledby={`customer-tab-${index}`}
      {...other}
    >
      <Box m={0} p={0}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `customer-tab-${index}`,
    'aria-controls': `customer-tabpanel-${index}`,
  };
}

export default function CustomersView() {

  const MyStateRole = useSelector(state => state.role);
  const UserId = useSelector(state => state.userid);
  const RoleId = useSelector(state => state.roleId);
  const Token = useSelector(state => state.accessToken);
  const isAccounting = (MyStateRole === "accounting") ? true : false;
  const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
  const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
  const isSupport = (MyStateRole === "support") ? true : false;
  const isDealerAdmin = (MyStateRole === "dealeradmin") ? true : false;
  const isDealerOperator = (MyStateRole === "dealeroperator") ? true : false;
  const UserFirstName = useSelector(state => state.firstName);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const [openBilledCustDialog, setOpenBilledCustDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openBilledCustViewDialog, setOpenBilledCustViewDialog] = useState(false);
  const [openBilledCustConfirmationDialog, setOpenBilledCustConfirmationDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedRowBilledCust, setSelectedRowBilledCust] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [productType, setProductType] = useState('');
  const [productTypeList, setProductTypeList] = useState([]);
  const [productId, setProductId] = useState(null);
  // const [openProbeGrpCount, setOpenProbeGrpCount] = useState(false);
  // const [selectedProbeGrpRow, setSelectedProbeGrpRow] = useState([]);

  const [licensesData, setLicensesData] = useState([]);
  const [openAddCustomerDialog, setOpenAddCustomerDialog] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const licensesDataRef = useRef();
  const licensesHistDataRef = useRef([]);

  const [openProbeDialog, setOpenProbeDialog] = useState(false);
  const [probeData, setProbeData] = useState(null);
  const probeStatusListRef = useRef([]);
  const [probeStatusList, setProbeStatusList] = useState([]);

  const MAX_NUM_VIEWS = 200;  //DB check constraint x >= 1 and x <=200
  const PRODUCT_TYPES = ["mavric-cloud", "mavric-monitoring-onprem"];
  const [orgNameOptions, setOrgNameOptions] = useState([]);
  const [customerIdOptions, setCustomerIdOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);

  const [muiTableKey, setMuiTableKey] = useState(0);
  const [muiBilledCustTableKey, setMuiBilledCustTableKey] = useState(0);
  const [selectedBilledCustomers, setSelectedBilledCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [confirmDeleteOpenBilledCust, setConfirmDeleteOpenBilledCust] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteMessageConfirmBilledCust, setDeleteMessageConfirmBilledCust] = useState("");
  const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
  const [deleteMessageConfirmTitleBilledCust, setDeleteMessageConfirmTitleBilledCust] = useState("");
  const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
  const [pageAlertType, setPageAlertType] = useState("error"); //error, warning, info, success
  const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;
  const [deleteAlertMsg, setDeleteAlertMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [billedData, setBilledData] = useState([]);
  const [demoData, setDemoData] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [tabList, setTabList] = useState([]);
  const [originalData, setOriginalData] = useState(null);
  const [showProbeTable, setShowProbeTable] = useState(false);
  const [showDemoProbeTable, setShowDemoProbeTable] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  useEffect(() => {
    if (!MyStateRole) return;

    switch (MyStateRole) {
      case 'salesadmin':
        setTabList(['Demo Customers', 'Billed Customers']);
        // setTabValue(0);
        // setIsReadOnly(false);
        break;
      case 'accounting':
        setTabList(['Billed Customers', 'Demo Customers']);
        // setIsReadOnly(false);
        // setTabValue(0);
        break;
      case 'support':
        setTabList(['Billed Customers', 'Demo Customers']);
        // setIsReadOnly(true);
        // setTabValue(0);
        break;
      default:
        setTabList(['Demo Customers', 'Billed Customers']);
      // setTabValue(0);
      // setIsReadOnly(true);
    }
  }, [MyStateRole]);

  const getCustomerData = () => {
    // console.log("Token::", Token);
    return new Promise(function (resolve, reject) {
      getCustomers().then((response) => {
        //setProcessing(false);
        setCustDataList(response);
        resolve(response);
      }).catch((error) => {
        //setProcessing(false);
        setCustDataList([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getBilledCustomersData = () => {
    // console.log("Token::", Token);
    setIsLoading(true);
    return new Promise(function (resolve, reject) {
      getBilledCustomers().then((response) => {
        // console.log("API Response:", response);
        // setBilledData(response);
        // if (response && Array.isArray(response.payload)) {
        const data = response ? response : [];
        setBilledData(data);
        // setBilledData(response);
        // } 
        resolve(response);
        setIsLoading(false);
      }).catch((error) => {
        setBilledData([]);
        setIsLoading(false);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getDemoCustomersData = () => {
    // console.log("Token::", Token);
    setIsLoading(true);
    return new Promise(function (resolve, reject) {
      getDemoCustomers().then((response) => {
        if (response) {
          setDemoData(response);
        } else {
          setDemoData([]);
        }
        resolve(response);
        setIsLoading(false);
        // const data = response ? response : [];
        // setDemoData(data);
        // resolve(data);
      }).catch((error) => {
        setDemoData([]);
        setIsLoading(false);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getProductTypesData = () => {
    return new Promise(function (resolve, reject) {
      getProductTypes().then((response) => {
        // console.log("Response::", response);
        //setProcessing(false);
        setProductTypeList(response);
        resolve(response);
      }).catch((error) => {
        //setProcessing(false);
        setProductTypeList([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getLicensesData = () => {
    return new Promise(function (resolve, reject) {
      getLicenses().then((response) => {
        // console.log('getLicensesData : response :', response);
        let licenseData = response;
        if (Array.isArray(response) && response.length > 0) {
          response.map((licenseRow) => {
            if (!(licenseRow.lic_ref_value)) {
              licenseRow['lic_ref_value'] = "";
            }
            licenseData.push(licenseRow);
          });
        }
        //setProcessing(false);
        setLicensesData(licenseData);
        resolve(licenseData);
      }).catch((error) => {
        //setProcessing(false);
        setLicensesData([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getLicenseHistoryDataForCustomerId = (customerId) => {
    return new Promise(function (resolve, reject) {
      getLicenseHistoryByCustomerId(customerId).then((response) => {
        //setProcessing(false);
        //console.log('getLicenseHistoryDataForCustomerId : response :', response);

        if (Array.isArray(response)) {
          let tmpResponse = [];
          response.map((row, idx) => {
            let historyRow = row;
            if (!(historyRow.lic_ref_value)) {
              historyRow['lic_ref_value'] = null;
            }
            if (!(historyRow.lic_start)) {
              historyRow['lic_start'] = "";
            }

            if (!(historyRow.lic_end)) {
              historyRow['lic_end'] = "";
            }

            tmpResponse.push(historyRow);
          });
          licensesHistDataRef.current = tmpResponse;
          resolve(tmpResponse);
        } else {
          licensesHistDataRef.current = response;
          resolve(response);
        }
      }).catch((error) => {
        //setProcessing(false);
        licensesHistDataRef.current = [];
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };


  const getAuthProviderData = () => {
    // console.log("Token::", Token);
    return new Promise(function (resolve, reject) {
      getAuthProviders().then((response) => {
        setAuthProviderList(response);
        resolve(response);
      }).catch((error) => {
        setAuthProviderList([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const getAuthProviderDataByCustomerId = (customerId) => {
    // console.log("Fetching SSO AuthProvider for Customer ID:", customerId);
    return new Promise(function (resolve, reject) {
      getAuthProviderByCustomerId(customerId)  // API call to get SSO AuthProvider details
        .then((response) => {
          setAuthProviderData(response);
          // console.log(response);
          resolve(response);
        })
        .catch((error) => {
          setAuthProviderData([]);
          let errMessage = '';
          if (error.response) {
            errMessage = error.response.data.message;
            if (error.response.status === 401 || error.response.status === 403) {
              let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
              dispatch(logout(jsonPostMsg));
              history.push('/login');
            }
          } else if (error.request) {
            errMessage = `${error}`;
            console.log(error.request);
          } else {
            console.log('Error', error.message);
            errMessage = error.message;
          }
          reject(errMessage);
        });
    });
  };

  const getProbesByCustomerId = (customerId, customer_name) => {
    return new Promise(function (resolve, reject) {
      getProbeListByCustomerId(customerId).then((response) => {
        let probeData = response;
        probeData.customer_name = customer_name;
        //setProcessing(false);
        setProbeData(probeData);
        resolve(probeData);
      }).catch((error) => {
        //setProcessing(false);
        setProbeData([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            // <Redirect from="/" to="/login" />
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };


  const getUserRolesData = () => {
    // console.log("Token::", Token);
    return new Promise(function (resolve, reject) {
      getUserRoles().then((response) => {
        setUserRoleList(response);
        resolve(response);
      }).catch((error) => {
        setUserRoleList([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };


  //  useEffect(()=>{
  //         console.log("formData:--------->",formData);

  //     },[formData])

  useEffect(() => {
    // getCustomerData();
    getProductTypesData();
    getBilledCustomersData();
    getDemoCustomersData();
    // getLicensesData();
    // getAuthProviderData();
    // getUserRolesData();
  }, []);

  useEffect(() => {
    licensesDataRef.current = licensesData;
  }, [licensesData]);


  useEffect(() => {
  }, [licensesHistDataRef.current]);


  useEffect(() => {
    let activeProbes = [];
    let inactiveProbes = [];
    if (probeData) {
      if (probeData.active_probes_list &&
        Array.isArray(probeData.active_probes_list) &&
        probeData.active_probes_list.length > 0
      ) activeProbes = probeData.active_probes_list.map(probe => ({ ...probe, probe_status: "ACTIVE" }));
      if (probeData.inactive_probes_list &&
        Array.isArray(probeData.inactive_probes_list) &&
        probeData.inactive_probes_list.length > 0
      ) inactiveProbes = probeData.inactive_probes_list.map(probe => ({ ...probe, probe_status: "INACTIVE" }))
    }
    probeStatusListRef.current = activeProbes.concat(inactiveProbes);
    setProbeStatusList([...activeProbes, ...inactiveProbes])
  }, [probeData]);


  const handleBilledCustClickOpen = (row) => {
    setSelectedRowBilledCust(row);
    setOriginalData(row);
    setProductType(row.product_type);
    setProductId(row.product_id);
    // setFormData(row); // Populate form data with the selected row
    setOpenBilledCustDialog(true);
  };

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOriginalData(row);
    setProductType(row.product_type);
    setProductId(row.product_id);
    // setFormData(row); // Populate form data with the selected row
    setOpenDialog(true);
  };

  const handleClickOpenBilledCustomerDetailView = (row) => {
    setSelectedRowBilledCust(row);
    setProductType(row.product_type);
    // setProductId(row.product_id);
    // setFormData(row); // Populate form data with the selected row
    setOpenBilledCustViewDialog(true);
    //console.log("Row Data:", row);
  };

  const handleClickOpenCustomerDetailView = (row) => {
    setSelectedRow(row);
    setProductType(row.product_type);
    // setProductId(row.product_id);
    // setFormData(row); // Populate form data with the selected row
    setOpenViewDialog(true);
    //console.log("Row Data:", row);
  };

  const handleBilledCustCloseDialog = () => {
    setOpenBilledCustDialog(false);
    setSelectedRowBilledCust(null);
    setOriginalData(null);
    setShowProbeTable(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setOriginalData(null);
    setShowDemoProbeTable(false);
  };

  const handleCloseViewBilledCustomerDialog = () => {
    setOpenBilledCustViewDialog(false);
    setSelectedRowBilledCust(null);
  };

  const handleCloseViewCustomerDialog = () => {
    setOpenViewDialog(false);
    setSelectedRow(null);
  };


  const handleCloseMonitorListDialog = () => {
    setOpenMonitorUserListDialog(false)
    setFormData(null);
  };

  const handleCloseBilledCustConfirmation = () => {
    setOpenBilledCustConfirmationDialog(false);
    // setOpenDialog(false);
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmationDialog(false);
    // setOpenDialog(false);
  };

  const handleOpenBilledCustConfirmation = () => {
    setOpenBilledCustConfirmationDialog(true);
    // setOpenDialog(false);
  };

  const handleOpenConfirmation = () => {
    setOpenConfirmationDialog(true);
    // setOpenDialog(false);
  };

  const handleBilledCustChange = (e) => {
    console.log(e);
    setSelectedRowBilledCust({ ...selectedRowBilledCust, [e.target.name]: e.target.value });
  };

  const handleDemoCustChange = (e) => {
    console.log(e);
    const { name, value } = e.target;
    setSelectedRow({ ...selectedRow, [e.target.name]: e.target.value });
  };

  const handleBilledCustProductTypeChange = (event) => {
    setProductType(event.target.value);
    if (event.target.value === PRODUCT_TYPES[0]) {
      setProductId(1);
    } else {
      setProductId(2);
    }
  };

  const handleProductTypeChange = (event) => {
    setProductType(event.target.value);
    if (event.target.value === PRODUCT_TYPES[0]) {
      setProductId(1);
    } else {
      setProductId(2);
    }
  };

  const handleOpenAddCustomerDialog = () => {
    setOpenAddCustomerDialog(true);
  };

  const handleCloseAddCustomerDialog = () => {
    setOpenAddCustomerDialog(false);
  };


  const handleDemoCustAccountStatusChange = async (event) => {
    const newStatus = event.target.value;
    const wasActive = selectedRow.is_active;
    // const nowInactive = newStatus === "inactive";
    setSelectedRow((prev) => ({
      ...prev,
      is_active: newStatus === 'active'
    }));
    setShowDemoProbeTable(wasActive);
    // console.log("showProbeTable:----->",showDemoProbeTable);

    if (wasActive) {
      try {
        const probes = await getProbesByCustomerId(selectedRow.customer_id);
        setProbeStatusList(probes || []);
      } catch (error) {
        console.error("Error fetching probes:", error);
        setProbeStatusList([]);
      }
    } else if (newStatus === 'active') {
      setProbeStatusList([]);
    }

  }

  const handleBilledCustAccountStatusChange = async (event) => {
    const newStatus = event.target.value;
    const wasActive = selectedRowBilledCust.is_active;
    // const nowInactive = newStatus === "inactive";
    // console.log("Billed CustAccount Status Change:--------->", newStatus);
    setSelectedRowBilledCust((prev) => ({
      ...prev,
      is_active: newStatus === 'active'
    }));
    setShowProbeTable(wasActive);
    // setShowProbeTable(wasActive && nowInactive);
    // console.log("showProbeTable:----->",showProbeTable);
    
    // console.log("setSelectedRowBilledCust:--------->", selectedRowBilledCust);

    if (wasActive) {
      try {
        const probes = await getProbesByCustomerId(selectedRowBilledCust.customer_id);
        setProbeStatusList(probes || []);
      } catch (error) {
        console.error("Error fetching probes:", error);
        setProbeStatusList([]);
      }
    } else if (newStatus === 'active') {
      // Clear probes when changing to Active
      setProbeStatusList([]);
    }

  };

  const handleBilledCustAccountTypeChange = (event) => {
    const newType = event.target.value;
    // console.log("Billed Cust AccountType Change:--------->", newType);
    setSelectedRowBilledCust((prev) => ({
      ...prev,
      act_type: newType
    }));
    // console.log("setSelectedRowBilledCust:--------->", selectedRowBilledCust);
  };

  useEffect(() => {
    // console.log("selectedRowBilledCust updated:", selectedRowBilledCust);
  }, [selectedRowBilledCust]);

  const handleSaveBilledCust = async () => {
    // console.log('Updated Data:', formData);
    // const updates = {};
    if (selectedRowBilledCust.customer_id !== null && productId !== null) {
      try {
        // await updateCustProductTypes(selectedRowBilledCust.customer_id, productId);
        if (productType !== originalData.product_type && productId !== null) {
          await updateCustProductTypes(selectedRowBilledCust.customer_id, productId);
          // updates.productTypeUpdated = true;
        }

        if (selectedRowBilledCust.is_active !== originalData.is_active) {
          if (selectedRowBilledCust.is_active) {
            await activateCustomerAccount(selectedRowBilledCust.customer_id);
          } else {
            await deactivateCustomerAccount(selectedRowBilledCust.customer_id);
          }
          // updates.statusUpdated = true;
        }
        if (selectedRowBilledCust.act_type !== originalData.act_type) {
          if (selectedRowBilledCust.act_type === 'demo') {
            await setCustomerAccountTypeToDemo(selectedRowBilledCust.customer_id);
          } else {
            await setCustomerAccountTypeToBilled(selectedRowBilledCust.customer_id);
          }
          // updates.accountTypeUpdated = true;
        }
        await getBilledCustomersData();  // Reload the updated data
        await getDemoCustomersData();
      } catch (error) {
        console.error("Error updating product type:", error);
      }
    }
    handleBilledCustCloseDialog();
    handleCloseBilledCustConfirmation();
  };
  
  const handleSave = async () => {
    // console.log('Updated Data:', formData);
    if (selectedRow.customer_id !== null && productId !== null) {
      try {
        if (productType !== originalData.product_type && productId !== null) {
          await updateCustProductTypes(selectedRow.customer_id, productId);
        }
        if (selectedRow.is_active !== originalData.is_active) {
          if (selectedRow.is_active) {
            await activateCustomerAccount(selectedRow.customer_id);
          } else {
            await deactivateCustomerAccount(selectedRow.customer_id);
          }
        }
        if (selectedRow.act_type !== originalData.act_type) {
          if (selectedRow.act_type === 'demo') {
            await setCustomerAccountTypeToDemo(selectedRow.customer_id);
          } else {
            await setCustomerAccountTypeToBilled(selectedRow.customer_id);
          }
        }

        await getBilledCustomersData();  // Reload the updated data
        await getDemoCustomersData();
      } catch (error) {
        console.error("Error updating product type:", error);
      }
    }
    handleCloseDialog();
    handleCloseConfirmation();
  };


  const hasChanges = () => {
    if (!selectedRow || !originalData) return false;
  
    return (
      productType !== originalData.product_type ||
      selectedRow.is_active !== originalData.is_active ||
      selectedRow.act_type !== originalData.act_type
    );
  };

  const hasChangesForBilled = () => {
    if (!selectedRowBilledCust || !originalData) return false;
  
    return (
      productType !== originalData.product_type ||
      selectedRowBilledCust.is_active !== originalData.is_active ||
      selectedRowBilledCust.act_type !== originalData.act_type
    );
  };


  const deleteCustomers = async (customerList) => {
    let errorList = [];
    let deletedCustomers = [];
    for (let idx = 0; idx < customerList.length; idx++) {
      let customerInfo = customerList[idx];
      try {
        await deleteCustomer(customerInfo.customer_id)
          .then((result) => {
            console.log(result);
            if (result.code != 200) {
              console.log("Error ocurred : result : ", result);
              customerInfo['error_msg'] = JSON.stringify(result);
              errorList.push(customerInfo);
            } else {
              deletedCustomers.push(customerInfo);
            }
          })
          .catch((error) => {
            customerInfo['error_msg'] = error;
            errorList.push(customerInfo);
          });
      } catch (error) {
        // console.log("Error ocurred : ", error);
        customerInfo['error_msg'] = error;
        errorList.push(customerInfo);
      }
    };

    setShowDeleteAlert(true);
    if ((errorList.length > 0)) {
      console.error("Customer List with error :", errorList);
      setPageAlertType("error");
      setDeleteAlertMsg(`Error: ${errorList.length} customer(s) were not deleted`);
    } else {
      setPageAlertType("success");
      setDeleteAlertMsg(`Success : ${deletedCustomers.length} customer(s) were deleted`);
    }

  }

  const handleDeleteBilledCustomer = () => {
    let strMsg = "Are you sure you want to delete?";
    setDeleteMessageConfirmBilledCust(strMsg);
    setDeleteMessageConfirmTitleBilledCust("Delete selected");
    setConfirmDeleteOpenBilledCust(true);
  };

  const handleDeleteCustomer = () => {
    let strMsg = "Are you sure you want to delete?";
    setDeleteMessageConfirm(strMsg);
    setDeleteMessageConfirmTitle("Delete selected");
    setConfirmDeleteOpen(true);
  };

  const handleConfirmCloseBilledCust = () => {
    setConfirmDeleteOpenBilledCust(false);
    setSelectedBilledCustomers([]);
  };

  const handleConfirmClose = () => {
    setConfirmDeleteOpen(false);
    setSelectedCustomers([]);
  };

  const handleDeleteYesBilledCust = async () => {
    setConfirmDeleteOpenBilledCust(false);
    if (selectedBilledCustomers.length > 0) {
      await deleteCustomers(selectedBilledCustomers);
      await getBilledCustomersData();
      // await getLicensesData();
    }
    setSelectedBilledCustomers([]);
    resetBilledCustFilters();
  }

  const handleDeleteYes = async () => {
    setConfirmDeleteOpen(false);
    if (selectedCustomers.length > 0) {
      await deleteCustomers(selectedCustomers);
      await getDemoCustomersData();
      // await getCustomerData();
      // await getLicensesData();
    }
    setSelectedCustomers([]);
    resetMyFilters();
  }

  const handleDeleteNoBilledCust = () => {
    setSelectedBilledCustomers([]);
    setConfirmDeleteOpenBilledCust(false);
    resetBilledCustFilters();
  };

  const handleDeleteNo = () => {
    setSelectedCustomers([]);
    setConfirmDeleteOpen(false);
    resetMyFilters();
  };

  const handleDeleteBilledCustAlertClose = (event, reason) => {

    if (reason === 'clickaway') {
      return;
    }
    setAlertState({ ...alertState, openAlert: false });
    setShowDeleteAlert(false);

  }

  const handleDeleteAlertClose = (event, reason) => {

    if (reason === 'clickaway') {
      return;
    }
    setAlertState({ ...alertState, openAlert: false });
    setShowDeleteAlert(false);

  }

  const resetBilledCustFilters = () => {
    setMuiBilledCustTableKey(muiBilledCustTableKey + 1);
  };

  const resetMyFilters = () => {
    setMuiTableKey(muiTableKey + 1);
  };

  return (
    <>
      <div>
        <Box sx={{ flexGrow: 1, }}>
          <Grid container direction="row" spacing={2} justifyContent="center" display="flex" mt={0}>
            {!isSupport && (<Grid item xs={12} sm={12} md={12} sx={{ mb: 1 }}>
              <Button
                variant="contained"
                sx={{ mr: 1 }}
                color="secondary"
                aria-label="Add New User"
                onClick={handleOpenAddCustomerDialog}
                endIcon={<AddIcon sx={{ backgroundColor: secondary.main }} size="small" />}
              >
                Add Customer
              </Button>
            </Grid>)}
            <Grid item xs={12} sm={12} md={12} >
              <Card>
                <CardContent sx={{ mt: 0, px:0 }}>

                  <Box sx={{ borderColor: 'primary.focus', padding:0 }}>
                    {tabList.length > 0 && (
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="secondary"
                        textColor="secondary"
                        allowScrollButtonsMobile={true}
                      >
                        {tabList.map((label, index) => (
                          <Tab key={label} label={label} {...a11yProps(index)} />
                        ))}
                      </Tabs>)}
                    <Divider sx={{ borderColor: primary.divider, mb: 2 }} />
                  </Box>

                  {tabList.map((tabLabel, index) => (
                    <TabPanel key={tabLabel} value={tabValue} index={index}>
                      {isLoading ? (
                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: 200,
                        }}>
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : tabLabel === 'Billed Customers' ? (
                        <BilledCustomers
                          muiBilledCustTableKey={muiBilledCustTableKey}
                          billedData={billedData}
                          productTypeList={productTypeList}
                          isAccounting={isAccounting}
                          isSalesAdmin={isSalesAdmin}
                          isSupport={isSupport}
                          alertState={alertState}
                          showDeleteAlert={showDeleteAlert}
                          setSelectedRowBilledCust={setSelectedRowBilledCust}
                          handleBilledCustClickOpen={handleBilledCustClickOpen}
                          handleClickOpenBilledCustomerDetailView={handleClickOpenBilledCustomerDetailView}
                          handleDeleteBilledCustomer={handleDeleteBilledCustomer}
                          resetBilledCustFilters={resetBilledCustFilters}
                          handleDeleteBilledCustAlertClose={handleDeleteBilledCustAlertClose}
                          deleteAlertMsg={deleteAlertMsg}
                          pageAlertType={pageAlertType}
                          openBilledCustDialog={openBilledCustDialog}
                          handleBilledCustCloseDialog={handleBilledCustCloseDialog}
                          selectedRowBilledCust={selectedRowBilledCust}
                          handleBilledCustChange={handleBilledCustChange}
                          handleBilledCustProductTypeChange={handleBilledCustProductTypeChange}
                          productType={productType}
                          probeStatusList={probeStatusList}
                          showProbeTable={showProbeTable}
                          // isSaveDisabled={isSaveDisabled}
                          hasChangesForBilled={hasChangesForBilled}
                          setSelectedBilledCustomers={setSelectedBilledCustomers}
                          openBilledCustConfirmationDialog={openBilledCustConfirmationDialog}
                          handleCloseBilledCustConfirmation={handleCloseBilledCustConfirmation}
                          handleSaveBilledCust={handleSaveBilledCust}
                          handleBilledCustAccountStatusChange={handleBilledCustAccountStatusChange}
                          handleBilledCustAccountTypeChange={handleBilledCustAccountTypeChange}
                          openBilledCustViewDialog={openBilledCustViewDialog}
                          handleCloseViewBilledCustomerDialog={handleCloseViewBilledCustomerDialog}
                          confirmDeleteOpenBilledCust={confirmDeleteOpenBilledCust}
                          handleConfirmCloseBilledCust={handleConfirmCloseBilledCust}
                          handleDeleteYesBilledCust={handleDeleteYesBilledCust}
                          handleDeleteNoBilledCust={handleDeleteNoBilledCust}
                          deleteMessageConfirmBilledCust={deleteMessageConfirmBilledCust}
                          deleteMessageConfirmTitleBilledCust={deleteMessageConfirmTitleBilledCust}
                          handleOpenBilledCustConfirmation={handleOpenBilledCustConfirmation}
                          // handleClickOpenCustomerDetailView={handleClickOpenCustomerDetailView}
                          getProbesByCustomerId={getProbesByCustomerId}
                        />
                      ) : (
                        <DemoCustomers
                          muiTableKey={muiTableKey}
                          demoData={demoData}
                          // columns={columns}
                          productTypeList={productTypeList}
                          isAccounting={isAccounting}
                          isSalesOperator={isSalesOperator}
                          isSalesAdmin={isSalesAdmin}
                          isSupport={isSupport}
                          isDealerAdmin={isDealerAdmin}
                          isDealerOperator={isDealerOperator}
                          alertState={alertState}
                          setSelectedCustomers={setSelectedCustomers}
                          handleClickOpen={handleClickOpen}
                          handleOpenConfirmation={handleOpenConfirmation}
                          handleCloseConfirmation={handleCloseConfirmation}
                          handleSave={handleSave}
                          
                          openViewDialog={openViewDialog}
                          handleCloseViewCustomerDialog={handleCloseViewCustomerDialog}
                          confirmDeleteOpen={confirmDeleteOpen}
                          handleConfirmClose={handleConfirmClose}
                          handleDeleteYes={handleDeleteYes}
                          handleDeleteNo={handleDeleteNo}
                          handleClickOpenCustomerDetailView={handleClickOpenCustomerDetailView}
                          handleDeleteCustomer={handleDeleteCustomer}
                          resetMyFilters={resetMyFilters}
                          handleDeleteAlertClose={handleDeleteAlertClose}
                          openDialog={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          selectedRow={selectedRow}
                          setSelectedRow={setSelectedRow}
                          handleChange={handleDemoCustChange}
                          handleProductTypeChange={handleProductTypeChange}
                          productType={productType}
                          // isSaveDisabled={isSaveDisabled}
                          hasChanges={hasChanges}
                          openConfirmationDialog={openConfirmationDialog}
                          deleteAlertMsg={deleteAlertMsg}
                          pageAlertType={pageAlertType}
                          deleteMessageConfirm={deleteMessageConfirm}
                          deleteMessageConfirmTitle={deleteMessageConfirmTitle}

                          handleDemoCustAccountStatusChange={handleDemoCustAccountStatusChange}
                          probeStatusList={probeStatusList}
                          getProbesByCustomerId={getProbesByCustomerId}
                          setShowDemoProbeTable={setShowDemoProbeTable}
                          showDemoProbeTable={showDemoProbeTable}
                        />
                      )}
                    </TabPanel>
                  ))}
                </CardContent>
              </Card>


            </Grid>
          </Grid>
          <AddCustomerDialog
            open={openAddCustomerDialog}
            getBilledCustomersData={getBilledCustomersData}
            getDemoCustomersData={getDemoCustomersData}
            handleClose={handleCloseAddCustomerDialog}
            userRole={MyStateRole} />
        </Box>
      </div >
    </>
  );
}
